module.exports = __webpack_public_path__ + "static/media/9.3c474c15.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/9.png
// module id = 1504
// module chunks = 0